export default function TwoDecimalsMoneyRenderer(money) {
    return parseFloat(money).toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
